import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ChatDialogComponent } from './chat-dialog.component';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/shared/material.module';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [ChatDialogComponent],
  imports: [
    CommonModule,
    MaterialModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
  ],
})
export class ChatDialogModule {}
